import { em } from 'polished'
import styled from 'styled-components'

export const ModalRoot = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2147483647;
`

export const ModalOverlay = styled.button.attrs({
  className: 'default-styles',
  type: 'button',
})`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
`

export const ModalScroller = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: ${em(20)};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${p => p.theme.mq.upMd} {
    padding: ${em(40)} ${em(32)};
  }
`

export const ModalCard = styled.div`
  position: relative;
  width: 100%;
  max-width: ${em(320)};
  min-height: ${em(730)};
  padding: ${em(30)} ${em(20)} ${em(20)};
  border-radius: ${em(20)};
  background: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    max-width: ${em(556)};
    min-height: ${em(700)};
    padding: ${em(35)} ${em(40)} ${em(30)};
  }
`

export const CloseButton = styled.button.attrs({
  className: 'default-styles',
  type: 'button',
})`
  position: absolute;
  top: ${em(15)};
  right: ${em(15)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${em(18)};
  height: ${em(18)};
  padding: 0;
  border: 0 !important;
  background: transparent !important;
  cursor: pointer;
  appearance: none;
  z-index: 3;
  transition: opacity ${p => p.theme.animation.timeStandard} ease;

  &:hover {
    opacity: 0.5;
  }

  ${p => p.theme.mq.upMd} {
    top: -${em(28)};
    right: 0;
  }
`

export const CloseIcon = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

export const ModalTitle = styled.h2`
  margin: 0 auto;
  width: 280px;
  color: #1d1d1f;
  font-family: ${p => p.theme.typography.fontDruk};
  font-weight: 500;
  font-size: ${em(30)};
  line-height: ${em(30, 30)};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  letter-spacing: 0.03em;

  ${p => p.theme.mq.upMd} {
    width: calc(100% + 80px);
    margin-left: -40px;
    margin-right: -40px;
    font-size: ${em(40)};
    line-height: ${em(40, 40)};
    letter-spacing: -0.025em;
    white-space: nowrap;
  }
`

export const ModalTitleBreak = styled.span`
  display: block;

  ${p => p.theme.mq.upMd} {
    display: inline;
  }
`

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};
  margin-top: ${em(30)};

  ${p => p.theme.mq.upMd} {
    align-items: center;
    margin-top: ${em(35)};
  }
`

export const StepCard = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${em(190)};
  padding: ${em(15)};
  border-radius: ${em(27.23)};
  background: #f5f5f5;

  ${p => p.theme.mq.upMd} {
    width: ${em(416)};
    height: ${em(180)};
    padding: ${em(20)};
  }
`

export const StepBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${em(28)};
  height: ${em(28)};
  border-radius: 50%;
  background: ${p => p.theme.colors.black};
  color: ${p => p.theme.colors.white};
  font-family: ${p => p.theme.typography.mediumFont};
  font-size: ${em(16)};
  line-height: ${em(20, 16)};
`

export const StepText = styled.p`
  position: relative;
  z-index: 2;
  margin: ${em(15)} 0 0;
  max-width: ${p => (p.$wide ? em(220) : em(180))};
  color: ${p => p.theme.colors.black};
  font-size: ${em(16)};
  line-height: ${em(20, 16)};
  white-space: pre-wrap;

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(20)};
    max-width: ${p => (p.$wide ? em(292) : em(238))};
  }
`

export const StepNoteRow = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  gap: ${em(6)};
  margin-top: ${em(10)};

  ${p => p.theme.mq.upMd} {
    align-items: center;
  }
`

export const StepNoteIcon = styled.img`
  display: block;
  flex-shrink: 0;
  width: ${em(20)};
  height: ${em(20)};
`

export const StepNoteText = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.3);
  font-size: ${em(16)};
  line-height: ${em(20, 16)};
  white-space: pre-wrap;
`

export const StepLink = styled.span`
  color: #7645ef;
  font-family: ${p => p.theme.typography.mediumFont};
  text-decoration: underline;
  text-decoration-skip-ink: none;
`

export const StepOneIllustrationFrame = styled.div`
  position: absolute;
  left: ${em(139.299)};
  top: ${em(65)};
  display: block;
  width: ${em(124.485)};
  height: ${em(165.42)};
  overflow: hidden;
  pointer-events: none;

  ${p => p.theme.mq.upMd} {
    left: ${em(236)};
    top: ${em(24)};
    width: ${em(156.204)};
    height: ${em(208)};
  }
`

export const StepOneIllustration = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: 55.5% 50%;
  pointer-events: none;

  ${p => p.theme.mq.upMd} {
    position: relative;
    left: 0;
    top: ${em(17)};
    width: 105%;
    height: auto;
    object-fit: contain;
    object-position: left top;
  }
`

export const StepTwoIllustration = styled.div`
  position: absolute;
  left: ${em(105)};
  top: ${em(26)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${em(218.903)};
  height: ${em(235.528)};

  ${p => p.theme.mq.upMd} {
    left: ${em(193)};
    top: -${em(32)};
    width: ${em(275.292)};
    height: ${em(299.35)};
  }
`

export const StepTwoIllustrationFrame = styled.div`
  position: relative;
  width: ${em(186.56)};
  height: ${em(206.927)};
  transform: rotate(-9.75deg);
  transform-origin: center;

  ${p => p.theme.mq.upMd} {
    width: ${em(247.782)};
    height: ${em(274.832)};
    transform: rotate(-6.03deg);
  }
`

export const StepTwoIllustrationImage = styled.img`
  position: absolute;
  left: 4.34%;
  top: 10.57%;
  display: block;
  width: 96.17%;
  height: 69.65%;
  max-width: none;
`

export const StepThreeIllustration = styled.div`
  position: absolute;
  right: -${em(27)};
  top: ${em(103)};
  width: ${em(125.547)};
  height: ${em(75.395)};
  overflow: hidden;

  ${p => p.theme.mq.upMd} {
    right: -${em(74)};
    top: ${em(34)};
    width: ${em(203.153)};
    height: ${em(122)};
  }
`

export const StepThreeLaptop = styled.img`
  position: absolute;
  left: -15.65%;
  top: -6.59%;
  display: block;
  width: 132.24%;
  height: 115.49%;
  max-width: none;
`

export const StepThreeScreenFrame = styled.div`
  position: absolute;
  left: ${em(18.32)};
  top: ${em(5.25)};
  width: ${em(89.692)};
  height: ${em(57.97)};
  overflow: hidden;

  ${p => p.theme.mq.upMd} {
    left: ${em(29.64)};
    top: ${em(8.49)};
    width: ${em(145.135)};
    height: ${em(93.804)};
  }
`

export const StepThreeScreen = styled.img`
  position: absolute;
  left: 0;
  top: -0.2%;
  display: block;
  width: 100%;
  height: 101.92%;
  max-width: none;
`

export const DesktopOnlyBreak = styled.br`
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
  }
`

export const MobileOnlyBreak = styled.br`
  display: block;

  ${p => p.theme.mq.upMd} {
    display: none;
  }
`

export const StepTwoNoteText = styled(StepNoteText)`
  ${p => p.theme.mq.upMd} {
    white-space: nowrap;
  }
`

export const StepThreeText = styled(StepText)`
  max-width: ${em(187)};

  ${p => p.theme.mq.upMd} {
    max-width: ${em(250)};
  }
`

export const StepTwoText = styled(StepText)`
  max-width: ${em(220)};

  ${p => p.theme.mq.upMd} {
    max-width: ${em(292)};
  }
`

export const StepThreeHint = styled.p`
  position: relative;
  z-index: 2;
  margin: ${em(10)} 0 0;
  color: rgba(0, 0, 0, 0.3);
  font-size: ${em(16)};
  line-height: ${em(20, 16)};
`
